export const PORTAL_LAYER_ATTRIBUTE = "data-portal-layer"

export const PORTAL_LAYER_PROPS = { [PORTAL_LAYER_ATTRIBUTE]: "" } as const

export const PORTAL_LAYER_SELECTOR = `[${PORTAL_LAYER_ATTRIBUTE}], [data-slot$=dialog-overlay], [role=dialog], [role=alertdialog]`

export function isInPortalLayer(target: EventTarget | null) {
  return target instanceof Element && target.closest(PORTAL_LAYER_SELECTOR) !== null
}
